import { render, staticRenderFns } from "./bv-transition.vue?vue&type=template&id=f91d4ca8"
import script from "./bv-transition.vue?vue&type=script&lang=js"
export * from "./bv-transition.vue?vue&type=script&lang=js"
import style0 from "./bv-transition.vue?vue&type=style&index=0&id=f91d4ca8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../apps/gouwubao/node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports